export enum AnnouncementType {
  DOMAIN = 'DOMAIN' /* early media announcements **/,
  EARLY_MEDIA = 'EARLY_MEDIA' /* music on hold annoucements **/,
  MUSIC_ON_HOLD = 'MUSIC_ON_HOLD' /* park announcements */,
  PARK_SERVER = 'PARK_SERVER' /* announcements for ACLs */,
  BLACK_WHITE_LIST = 'BLACK_WHITE_LIST' /* announcements for ACDs */,
  ACD = 'ACD' /* announcements for Dedicated Conference */,
  DEDICATED_CONFERENCE = 'DEDICATED_CONFERENCE' /* announcements for AdHoc Conference */,
  ADHOC_CONFERENCE = 'ADHOC_CONFERENCE' /* announcements for Permanent call recording */,
  CALL_RECORDING = 'CALL_RECORDING',
}
